<ion-app>
    <!-- <ion-menu side="start" contentId="main-content">
    <ion-header>
      <ion-toolbar>
        <ion-title>Menu</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        <ion-item routerLink="/home">
          <ion-icon name="home-outline" slot="start"></ion-icon>
          <ion-label>Home</ion-label>
        </ion-item>
        <ion-item routerLink="/profile">
          <ion-icon name="person-outline" slot="start"></ion-icon>
          <ion-label>Profile</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-menu> -->

    <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>